import { render, staticRenderFns } from "./PolizasTable.vue?vue&type=template&id=3c68c7de"
import script from "./PolizasTable.vue?vue&type=script&lang=js"
export * from "./PolizasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports